<template>
  <div>

    <breadcrumb></breadcrumb>

    
    <div class="row">
      <div class="col">
          <table class="table table-sm">
            <thead class="thead-dark">
              <tr>
                <th scope="col">Nome</th>
                <th scope="col">Unidade</th>
                <th scope="col">Medida</th>
                <th scope="col">Cota</th>
                <th scope="col">Kcal</th>
                <th scope="col">C</th>
                <th scope="col">P</th>
                <th scope="col">G</th>
                <th scope="col">F</th>
                <th scope="col">GS</th>
                <th scope="col">Na</th>
                <th scope="col">Indice</th>
                <th scope="col">COR</th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="item in data" :key="item._id">
                  <td scope="row">{{item.nome}}</td>
                  <td scope="row">{{item.unidade}}</td>
                  <td scope="row">{{item.medida}}</td>
                  <td scope="row">{{item.cota}}</td>
                  <td scope="row">{{item.kcal ? item.kcal.toFixed(2) : '0'}}</td>
                  <td scope="row">{{item.c ? item.c.toFixed(2) : '0'}}</td>
                  <td scope="row">{{item.p ? item.p.toFixed(2) : '0'}}</td>
                  <td scope="row">{{item.g ? item.g.toFixed(2) : '0'}}</td>
                  <td scope="row">{{item.f ? item.f.toFixed(2) : '0'}}</td>
                  <td scope="row">{{item.gs ? item.gs.toFixed(2) : '0'}}</td>
                  <td scope="row">{{item.na ? item.na.toFixed(2) : '0'}}</td>
                  <td scope="row">{{item.indice ? item.indice : '0'}}</td>
                  <td>
                    <svg class="w-6 h-6 p-1" :class="getCorNovo(item)" fill="currentColor" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50"/></svg>
                  </td>
                  <td>
                    <select @change="updateCor(item)" v-model="item.indiceSigla" name="indiceSigla" id="indiceSigla" class="form-control form-control-sm" style="margin-top:8px;margin-right: 10px;width: 120px">
                      <option value="">Automático</option>
                      <option value="REDHARD700">VERMELHO</option>
                      <option value="YELLOW400">AMARELO</option>
                      <option value="GREEN700">VERDE</option>
                    </select>
                  </td>

                  <td>
                    <router-link  title="Edit" :to="{ name: 'AlimentoEdit', params: { id: item._id } }">
                      editar
                    </router-link>
                    /
                    <a href="javascript;" @click.prevent="remove(item._id)" title="Remover">remover</a>
                  </td>
                </tr>
              </tbody>
          </table>

      </div>
    </div>
  </div>
</template>

<script>
import ls from 'local-storage'

export default {
  name: 'AlimentoAppHome',
  data() {
    return {
      data: [],
      api: '',
      token: ''
    }
  },
  methods: {
    updateCor(item) {
      this.$http.put('v1/alimento', item).then(response => {
        console.log(response.data);
      });
    },
    getCorNovo(a) {
      switch (true) {
        case (a.indiceSigla === 'REDHARD700'):
          return {'REDHARD700': true};

        case (a.indiceSigla === 'YELLOW400'):
          return {'YELLOW400': true};

        case (a.indiceSigla === 'GREEN700'):
          return {'GREEN700': true};
      }

      if (a.indice > 0) return {'GREEN700': true};
      if (a.indice === 0) return {'YELLOW400': true};
      if (a.indice < 0) return {'REDHARD700': true};
    },
    remove(id) {
      this.$http.delete(`/v1/alimento/${id}`).then(() => {
        this.$http.get('/v1/alimento').then((response) => {
          this.data = response.data.data;
        });
      })
    }
  },
  beforeMount() {
    this.api = process.env.API_ENV
    this.token = ls('token')

    this.$http.get('/v1/alimento/app').then((response) => {
      this.data = response.data.data
    });
  }
}
</script>

<style scoped>
  .h-6 {
    height: 46px;
  }
  .w-6 {
    height: 46px;
  }
 .REDHARD700{
    border: 0 solid #e5e7eb;
    border-collapse: collapse;
    border-spacing: 2px;
    box-sizing: border-box;
    color: #b91c1c;
    font-family: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
 }
 .RED500{
  border: 0 solid #e5e7eb;
  border-collapse: collapse;
  border-spacing: 2px;
  box-sizing: border-box;
  color: #ef4444;
  font-family: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
 }
 .YELLOW400 {
   border: 0 solid #e5e7eb;
    border-collapse: collapse;
    border-spacing: 2px;
    box-sizing: border-box;
    color: #fbbf24;
    font-family: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
 }
 .GREEN200 {
   border: 0 solid #e5e7eb;
  border-collapse: collapse;
  border-spacing: 2px;
  box-sizing: border-box;
  color: #a7f3d0;
  font-family: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
 }
 .GREEN400 {
    border: 0 solid #e5e7eb;
    border-collapse: collapse;
    border-spacing: 2px;
    box-sizing: border-box;
    color: #34d399;
    font-family: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
 }
 .GREEN700 {
    border: 0 solid #e5e7eb;
    border-collapse: collapse;
    border-spacing: 2px;
    box-sizing: border-box;
    color: #059669;
    font-family: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
 }
</style>


// WEBPACK FOOTER //
// src/components/alimentoapp/AlimentoHome.vue